import { TreeValueType } from 'esa-ui-library/lib/types';
import { PropertyType as PT } from '..';

const flattenChildren = (children: PT[]) => {
	let flat: PT[] = [];

	children?.forEach((c) => {
		if (!c.options) return (flat = [...flat, c]);
		flat = [...flat, c, ...flattenChildren(c.options)];
		delete c.options;
	});

	return flat;
};

export const flattenPartners = (partnerIds: string[], partners: PT[]): PT[] => {
	const flat = structuredClone(partners);

	flat.forEach((p: PT) => {
		const children = flattenChildren(p.options);
		p.options = children;
		p.active = children.filter((c) => partnerIds.includes(c.value)).length;
	});

	return flat;
};

export const flattenAll = (partners: PT[]): PT[] => {
	let flat = structuredClone(partners);

	flat.forEach((p: PT) => {
		const children = flattenChildren(p.options);
		flat = [...flat, ...children];
	});

	return flat;
};

export function searchNestedTree(nodes: TreeValueType[], searchTerm: string): TreeValueType[] {
	return nodes.reduce((curr: TreeValueType[], item) => {
		let active = [...curr];
		if (item.label && item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
			active.push(item);
		} else if (item.options) {
			active = active.concat(searchNestedTree(item.options, searchTerm));
		}

		return active;
	}, []);
}
